var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27729e-05 4.50002C8.27671e-05 4.63263 0.0527609 4.75981 0.146529 4.85357C0.240297 4.94734 0.367474 5.00002 0.500083 5.00002L12.2931 5.00002L9.14608 8.14602C9.0522 8.23991 8.99945 8.36725 8.99945 8.50002C8.99945 8.6328 9.0522 8.76013 9.14608 8.85402C9.23997 8.94791 9.36731 9.00065 9.50008 9.00065C9.63286 9.00065 9.7602 8.94791 9.85408 8.85402L13.8541 4.85402C13.9006 4.80758 13.9376 4.7524 13.9628 4.69165C13.988 4.63091 14.001 4.56579 14.001 4.50002C14.001 4.43425 13.988 4.36913 13.9628 4.30839C13.9376 4.24764 13.9006 4.19247 13.8541 4.14602L9.85408 0.146021C9.8076 0.099533 9.75241 0.0626569 9.69167 0.0374978C9.63093 0.0123387 9.56583 -0.000610545 9.50008 -0.000610548C9.36731 -0.000610554 9.23997 0.0521343 9.14608 0.146021C9.0522 0.239908 8.99945 0.367245 8.99945 0.500021C8.99945 0.632797 9.0522 0.760134 9.14608 0.854021L12.2931 4.00002L0.500083 4.00002C0.367474 4.00002 0.240297 4.0527 0.146529 4.14647C0.0527609 4.24024 8.27787e-05 4.36741 8.27729e-05 4.50002Z",
    fill: "#FF9933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.f990f0915d22cf53a815664e16b2deb7.svg";
export { ForwardRef as ReactComponent };